import React from 'react'
import { Navigate } from 'react-router-dom'
import { Result, Button } from 'antd'

import { useAuth } from '@/contexts/AuthContext'


// ======================================================
// Normalize Role
// ======================================================

const normalizeRole = (user) => {

  if (!user) return null

  const roles = []


  // Single role
  if (user.role) {
    roles.push(
      String(user.role)
        .trim()
        .toLowerCase()
    )
  }


  // Multiple roles
  if (Array.isArray(user.roles)) {

    user.roles.forEach((item) => {

      if (typeof item === 'string') {

        roles.push(
          item
            .trim()
            .toLowerCase()
        )

      } else if (item?.name) {

        roles.push(
          String(item.name)
            .trim()
            .toLowerCase()
        )

      } else if (item?.role) {

        roles.push(
          String(item.role)
            .trim()
            .toLowerCase()
        )

      }

    })

  }


  // Administrator
  if (
    roles.includes('administrator') ||
    roles.includes('admin')
  ) {
    return 'Administrator'
  }


  // Operations Manager
  if (roles.includes('om')) {
    return 'OM'
  }


  // Team Manager
  if (roles.includes('tm')) {
    return 'TM'
  }


  // Staff
  if (roles.includes('staff')) {
    return 'Staff'
  }


  return null
}


// ======================================================
// Product Route
// ======================================================

export const ProductRoute = ({
  productKey,
  children,
}) => {

  const {
    user,
    loading,
    isAuthenticated,
  } = useAuth()


  // ====================================================
  // Authentication still loading
  // ====================================================

  if (loading) {

    return (
      <div
        style={{
          minHeight: '240px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#64748b',
          fontSize: '13px',
        }}
      >
        Loading...
      </div>
    )

  }


  // ====================================================
  // Not authenticated
  // ====================================================

  if (!isAuthenticated || !user) {

    return (
      <Navigate
        to="/login"
        replace
      />
    )

  }


  // ====================================================
  // Normalize role
  // ====================================================

  const role = normalizeRole(user)


  // ====================================================
  // Administrator
  //
  // Administrator has FULL access to all products.
  // No purchasedProducts check is required.
  // ====================================================

  if (role === 'Administrator') {
    return children
  }


  // ====================================================
  // OM
  //
  // OM also has full product access.
  // ====================================================

  if (role === 'OM') {
    return children
  }


  // ====================================================
  // Purchased Products
  // ====================================================

  const purchasedList =
    Array.isArray(user.purchasedProducts)
      ? user.purchasedProducts
      : []


  // ====================================================
  // Product Access
  // ====================================================

  if (
    purchasedList.includes(productKey)
  ) {

    return children

  }


  // ====================================================
  // No Access
  // ====================================================

  return (

    <Result
      status="403"
      title="未订阅该模块"
      subTitle="您尚未开通此功能的访问权限，请联系管理员升级订阅。"
      extra={
        <Button
          type="primary"
          onClick={() => window.history.back()}
        >
          返回上一页
        </Button>
      }
    />

  )
}